import { dataInfoflow } from 'dls-icons-data'
import { createIcon } from '../common'

const IconInfoflow = /*#__PURE__*/createIcon(dataInfoflow)
export default IconInfoflow
